<script>
export default {
    props: {
        filter: Object,
    },
    data() {
        return {
            checkedValue: false,
        }
    },
    mounted() {
        this.checkedValue = this.$root.filter.pressImages == 'true';
    },
    watch: {
        filter(value) {
            if (value.reset) {
                this.checkedValue = false;
            }
        }
    },
    methods: {
        search() {
            this.$set(this.$root.filter, 'pressImages', !this.checkedValue);
            this.$nextTick(() => this.$root.startSearch());
        }
    }
}
</script>

<template>
    <div>
        <div class="m-b">
            <label class="form-check-label lh-34">
                <input class="form-check-input" type="checkbox" :checked="checkedValue" @change="search">
                Nur Pressebilder anzeigen
            </label>
        </div>
    </div>
</template>
